/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Devices_Disabled_TitleInputs */

const vi_irrigation_devices_disabled_title = /** @type {(inputs: Irrigation_Devices_Disabled_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tích hợp phun nước đang tắt`)
};

/**

* @param {Irrigation_Devices_Disabled_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_devices_disabled_title = /** @type {((inputs?: Irrigation_Devices_Disabled_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Devices_Disabled_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_devices_disabled_title(inputs)
});